import { CommonModule } from '@angular/common';
import {
  Component,
  forwardRef,
  HostBinding,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TagInputModule } from 'ngx-chips';

@Component({
  selector: 'doc-chips',
  standalone: true,
  imports: [CommonModule, FormsModule, TagInputModule],
  template: `
    <tag-input
      class="doc-chips-input"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      (onBlur)="markTouched()"
      [addOnBlur]="addOnBlur"
      [modelAsStrings]="true"
      [placeholder]="placeholder"
      [secondaryPlaceholder]="secondaryPlaceholder"
      [disable]="disabled"
      [required]="required ? '' : null">
    </tag-input>
  `,
  styleUrl: './doc-chips.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DocChipsComponent),
      multi: true,
    }],
})
export class DocChipsComponent implements ControlValueAccessor {
  @Input() addOnBlur = false;
  @Input() required = false;
  @Input() placeholder = '';
  @Input() secondaryPlaceholder = '';

  @HostBinding('class.doc-chips-host')
  readonly hostClass = true;

  value: string[] = [];
  disabled = false;

  private onChange: (value: string[]) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: string[] | null): void {
    this.value = Array.isArray(value) ? [...value] : [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: string[] | null): void {
    this.value = Array.isArray(value) ? value : [];
    this.onChange(this.value);
  }

  markTouched(): void {
    this.onTouched();
  }
}
